import { Box, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";
import { NoDataCard } from "../../../components/parts";
import { CustomPieChart } from "../../../components/charts";

const useStyles = makeStyles(() => ({
  chartBox: {
    height: 270,
    borderRadius: 8,
    marginTop: 20,
  },
  title: {
    padding: "10px 0 0 20px",
  },
}));

export const TotalRoofAreaPart = ({ roofAreaChartData }) => {
  const classes = useStyles();

  return (
    <Box style={{ backgroundColor: COLORS.darks[0][3], borderRadius: 8, height: "100%" }}>
      <Typography variant="h4" className={classes.title}>
        Total roof Area
      </Typography>
      <Box className={classes.chartBox}>
        {roofAreaChartData.length ? (
          <CustomPieChart name="area" data={roofAreaChartData} />
        ) : (
          <NoDataCard withShaDowBox={false} gridStyle={{ height: 160 }} />
        )}
      </Box>
    </Box>
  );
};
